<script>
    import { createEventDispatcher } from 'svelte';
	import { onMount } from 'svelte';
	export let items = [];
    export let showAllSteps = false;
	export let activeTabValue;

    const dispatch = createEventDispatcher();

	$: {
		if (Array.isArray(items) && items.length && items[0].value) {
			activeTabValue = items[0].value;
		}
	}

    const handleClick = (value, description, isComplete) => {
        activeTabValue = value;
        dispatch('tabClick', {
            value: value,
            description: description,
            isComplete: isComplete
        });
    }
</script>

<aside>
    <ul>
        {#if Array.isArray(items)}
            {#each items as item}
            <div class="d-flex">
                 <button id={item.label} class='{activeTabValue >= item.value ? 'active' : ''} {showAllSteps === true ? 'active' : ''}' on:click={() => handleClick(item.value, item.description, item.isComplete)}>
                    {#if activeTabValue >= item.value || showAllSteps}
                        <img src={item.imageSource} alt="wizard" height="30" width="30">
                    {/if}
                </button>
            </div>
                <div class="vl {activeTabValue >= item.value ? 'active' : ''} {showAllSteps === true ? 'active' : ''}"></div>
            {/each}
        {/if}
    </ul>
</aside>


<style>
    aside{
        overflow-y: hidden;
        overflow-x: hidden;
    }

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    aside{
        display: flex;
	    flex-direction: column;
	    justify-content: space-between;
	    align-items: center;
        position: sticky;
        max-height: 100vh;
        overflow-y: auto;
    }

	ul {
		flex-wrap: wrap;
		padding-left: 0;
		margin-bottom: -1;
		list-style: none;
        right: 0;
	}

    button{
        background-color: #bbc4ec;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        padding: 0.8em;
        cursor: pointer;
        display: flex;
		align-items: center;
		justify-content: center;
        border: none;
        -webkit-transition: all 0.5s linear;
        -moz-transition: all 0.5s linear;
        -o-transition: all 0.5s linear;
        transition: all 0.5s linear;
    }

    .vl{
        width: 8px;
        height: 80px;
        line-height: 30px;
        display: block;
        font-size: 20px;
        background: #bbc4ec;
        margin: auto;
        -moz-transition: all 0.5s linear;
        -o-transition: all 0.5s linear;
        transition: all 0.5s linear;
    }

    .vl.active{
        background-color: #2e3563;
    }

    ul .vl:last-child{
        display: none;
    }

    button.active{
        background-color: #2e3563;
        border: none;
    }

    @media(max-width: 1200px){
        aside{
            display: none;
        }
    }

</style>
